import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { RhfMuiTextArea } from '../../molecules/fields/rhf-mui-fields';

export const FormEditInvoiceData = ({ ocrMessage }: { ocrMessage: string }) => {
  const { setValue } = useFormContext();

  useEffect(() => {
    if (ocrMessage) {
      setValue('invoiceData', ocrMessage);
    } else {
      setValue('invoiceData', '');
    }
  }, [ocrMessage, setValue]);

  return (
    <div className='pt-12'>
      <RhfMuiTextArea name='invoiceData' placeholder='Invoice Data' rows={20} required parseError={(error) => error.message.toString()} />
    </div>
  );
};
